import React from "react";
import Grid from "../../GridCards/Grid";
const Configuracion = () => {
  return <Grid />;
};

export default Configuracion;
